// 运行时配置
import { injectFontFaces } from '@/utils/assets';
import { baseURL } from '@/utils/env';
import { RequestConfig } from '@alipay/bigfish';

// 字体 url 需拼接部署基路径，改为运行时注入 @font-face
injectFontFaces();

// 全局初始化数据配置，用于 Layout 用户信息和权限初始化
// 更多信息见文档：https://bigfish.antgroup-inc.cn/docs/api/runtime-config#getinitialstate
export async function getInitialState() {
  return {};
}

// request 配置参考文档：https://bigfish.antgroup-inc.cn/docs/guides/request
export const request: RequestConfig = {
  baseURL,
  withCredentials: true,
};
